<template>
  <BModal
    title="Finalização do atendimento"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    :hide-header-close="true"
    :centered="true"
    ok-title="Finalizar"
    cancel-title="Cancelar"
    v-model="mostrar"
    @ok="finalizar"
    @cancel="sair(false)">
    <div class="container__finalizacao">
      <div v-if="atendimento"
        class="informacao">
        <BBadge variant="dark">
          Barbeiro: {{ atendimento.funcionario.nome }}
        </BBadge>
        <p>Cliente: {{ atendimento.cliente.nome }}</p>
        <p v-if="atendimento.cliente.bonificacao"
          class="informacao__desconto">
          Desconto: {{ atendimento.cliente.bonificacao | currency }}
        </p>
        <p class="informacao__total">
          Total: {{ atendimento.total | currency }}
        </p>
      </div>
      <InputCondicaoPagamentos
        label="Condição de pagamento"
        name="inputCondicaoPagto"
        class="input__condicaopagto"
        v-model="form.condicaopgto" />
    </div>
  </BModal>
</template>

<script>
import {
  BModal,
  BBadge,
} from 'bootstrap-vue/es/components'
import InputCondicaoPagamentos from '../../components/input/InputCondicaoPagamentos.vue'
import GeradorMensagens from '@/mixins/GeradorMensagens'

export default {
  name: 'PainelFinalizacaoAtendimento',
  components: {
    BModal,
    BBadge,
    InputCondicaoPagamentos,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      resolve: null,
      mostrar: false,
      atendimento: null,
      form: this.valoresIniciaisForm(),
    }
  },
  methods: {
    valoresIniciaisForm() {
      return {
        condicaopgto: 'dinheiro',
      }
    },
    pop(atendimento) {
      this.limpar()

      this.atendimento = atendimento
      this.mostrar = true
      this.form = this.valoresIniciaisForm()

      return new Promise(resolve => {
        this.resolve = resolve
      })
    },
    async finalizar(event) {
      event.preventDefault()
      this.atendimento.condicaopgto = this.form.condicaopgto
      this.sair(this.atendimento)
    },
    retornaDadosGravar() {
      return {
        clienteId: this.clienteIndicacao._id,
        indicacoes: this.indicados,
        barbeiro: this.barbeiroIndicacao.nome,
        filial: this.barbeiroIndicacao.filial.nome,
      }
    },
    sair(resolve = false) {
      this.mostrar = false
      this.resolve(resolve)
    },
    limpar() {
      this.atendimento = null
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";
@import "@/scss/colors.scss";

.container__finalizacao {
  @media (min-width: $medium-size) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: auto;
  }
}

.informacao {
  @media (min-width: $medium-size) {
    grid-column: 1 / 3;
  }

  margin-bottom: 1rem;

  & > p {
    margin: 0;
  }

  &__desconto {
    color: $cor-azul;
  }

  &__total {
    color: $cor-verde;
    font-size: 1.4rem;
    font-weight: 500;
  }
}

.input {
  &__condicaopagto {
    @media (min-width: $medium-size) {
      grid-column: 3 / -1;
    }
  }
}

</style>
